import react from 'react';
import { LineChart } from '@components/chart/lineChart';
import * as am4charts from '@amcharts/amcharts4/charts';
import moment from 'moment';
import { drawXAxisLabels, drawYAxisLabelsLineChart, getData, getTooltipAdapter } from './lib';
import { useTranslation } from '@lib/useTypedTranslation';
import './styles.css';

export interface IBatteryLevelChart {
  data: IBatteryLevelData[],
  date: number,
  isLoading?: boolean
}

export interface IBatteryLevelData {
  local: string,
  level: number,
  smartBattery?: {
    serialNumber: string
  },
  device: {
    serialNumber: string
  }
}

export const BatteryLevelChart = (props: IBatteryLevelChart) => {
  const { t } = useTranslation(['translation', 'performance']);
  const title = t(`BATTERY_CHARGE_LEVEL_FOR`, { date: moment(props.date).utc().format('Do MMMM'), ns: 'translation' });
  const lineAndToolTipColour = '#5ECAEA';

  return (
    <div className="battery-charge-level-chart-container">
      <LineChart<any>
        cypressId="batteryChargeLevelChart"
        data={getData(props?.data)}
        series={[
          { visible: true,
            dataKey: 'level',
            description: t('CHARGE_LEVEL'),
            colour: lineAndToolTipColour
          }
        ]}
        title={title}
        className = "battery-charge-level"
        hasLegend={true}
        useAxisTooltip={true}
        drawXAxis={(_, xAxis: am4charts.DateAxis) => drawXAxisLabels(xAxis, props.date)}
        drawYAxis={(_, yAxis: am4charts.ValueAxis) => drawYAxisLabelsLineChart(yAxis)}
        adjustChartDimensions={{ length: 97.5, height: 240 }}
        hasNoSelectionOverlay={!props.isLoading}
        getSeriesToolTipAdapter={() => getTooltipAdapter(t)}
      />
    </div>
  );
};
